import { AuthenticationStore } from '@/state/authentication.store';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const unauthenticatedGuard: CanActivateFn = () => {
  const store = inject(AuthenticationStore);
  const router = inject(Router);
  const loggedIn = store.isLoggedIn();

  if (loggedIn) {
    router.navigateByUrl('/');
    return false;
  }

  return true;
};
